import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { RestService, ApiQueryParams } from '../lib/RestService';
import { setQueryParams } from '../lib/helpers';
import { CartItem } from './cart.service';

export class Order {
  ID:	number;
  LID: string;
  ID_1C: string;
  PAYED: string;
  PRICE: number;
  BASKET:	CartItem[];
  XML_ID:	string;
  MARKED:	string;
  USER_ID: number;
  RUNNING: string;
  VERSION: number;
  DEDUCTED:	string;
  RESERVED:	string;
  CURRENCY:	string;
  SUM_PAID:	number;
  COMMENTS:	string;
  STAT_GID:	string;
  STORE_ID:	number;
  CANCELED:	string;
  DATE_LOCK: Date;
  LOCKED_BY: number;
  DATE_BILL: Date;
  TAX_VALUE: number;
  STATUS_ID: string;
  CREATED_BY: number;
  COMPANY_ID: number;
  DATE_PAYED:	Date;
  BX_USER_ID: number;
  VERSION_1C:	string;
  UPDATED_1C:	string;
  DATE_STATUS: Date;
  ORDER_TOPIC: string;
  DATE_UPDATE: Date;
  DATE_INSERT: Date;
  DELIVERY_ID: number;
  DATE_MARKED: Date;
  EMP_PAYED_ID: number;
  AFFILIATE_ID: number;
  RECOUNT_FLAG:	string;
  RECURRING_ID: number;
  IS_RECURRING:	string;
  PAY_SYSTEM_ID: number;
  DATE_DEDUCTED: Date;
  EMP_STATUS_ID: number;
  EMP_MARKED_ID: number;
  REASON_MARKED: string;
  DATE_CANCELED: Date;
  EXTERNAL_ORDER:	string;
  ACCOUNT_NUMBER:	string;
  PRICE_DELIVERY:	number;
  ALLOW_DELIVERY:	string;
  PERSON_TYPE_ID: number;
  DISCOUNT_VALUE:	number;
  RESPONSIBLE_ID: number;
  TRACKING_NUMBER: string;
  EMP_CANCELED_ID: number;
  EMP_DEDUCTED_ID: number;
  DATE_PAY_BEFORE: Date;
  PAY_VOUCHER_NUM: number;
  ADDITIONAL_INFO: string;
  REASON_CANCELED: string;
  DELIVERY_DOC_NUM:	string;
  USER_DESCRIPTION:	string;
  PAY_VOUCHER_DATE: Date;
  DELIVERY_DOC_DATE: Date;
  DATE_ALLOW_DELIVERY: Date;
  REASON_UNDO_DEDUCTED:	string;
  EMP_ALLOW_DELIVERY_ID: number;
}

@Injectable()
export class OrderService extends RestService {

  private apiUrl = `${environment.apiUrl}shop/Order/`;
  public orderSuccessMsg: string = '';

  constructor(private http: HttpClient) {
    super();
  }

  public get(params?: ApiQueryParams): Promise<Order[] | any> {
    const apiUrl = setQueryParams(this.apiUrl, params);
    return this.http.get<Order[]>(apiUrl, {withCredentials: true})
      .toPromise()
      .catch(this.handleError);
  }

  public create(data: any): Promise<any> {
    return this.http.post(this.apiUrl, data, {withCredentials: true})
      .toPromise()
      .catch(this.handleError);
  }
}
